import React from "react";

function Main() {
  return (
    <div>
      <h1 className="title1">
        밍기뉴 팬방<br></br> 홈페이지
      </h1>
    </div>
  );
}

export default Main;
